module.exports = __webpack_public_path__ + "img/GHS08.a69e7ffc.webp";